export default __webpack_public_path__ + "static/media/bg_buy_oap.ee4587fa.svg";